import React from 'react'
import { AdminAssessments } from 'pages'
import { markingWordsHooks } from '.'

const MakingWordsAssessments = () => {
    const tabs = markingWordsHooks.useTabs()

    return (
        <AdminAssessments
            collapse={true}
            tabs={tabs}
        />
    )
}

export default MakingWordsAssessments